export default async function getPublicData(
  filePath,
  defaultValue = [],
  appBasePath = ''
) {
  try {
    const basePath =
      (appBasePath.slice(-1) === '/' ? appBasePath.slice(0, -1) : appBasePath) +
      '/data/';
    const path = filePath[0] === '/' ? filePath.slice(1) : filePath;
    const response = await fetch(basePath + path);
    return await response.json();
  } catch (error) {
    console.warn('[getPublicData] ERROR: ' + error.message);
    return defaultValue;
  }
}

export async function getPublicDataNoJson(
  filePath,
  defaultValue = [],
  appBasePath = ''
) {
  try {
    const basePath =
      (appBasePath.slice(-1) === '/' ? appBasePath.slice(0, -1) : appBasePath) +
      '/data/';
    const path = filePath[0] === '/' ? filePath.slice(1) : filePath;
    const response = await fetch(basePath + path);
    return response;
  } catch (error) {
    console.warn('[getPublicData] ERROR: ' + error.message);
    return defaultValue;
  }
}
